export const findItemByStatus = (row, status) =>
  row.agrouped ? row.items?.find((item) => item.status === status) : row.status === status ? row : null;
